import React, { useState, useEffect } from 'react';

import NumberInput from '~ComponentsImproved/Numpad';
import { useButton, useCurrency, useDispatch, useI18n } from '~Hooks';
import { addToast } from '~actions';
import { Box, Button } from '~Styles';

interface Props {
  title: string;
  numberInputTitle: string;
  amountRemaining: number;
  method: string;
  maxAmount?: number | null;
  onStartPay: (amount: number, method: string, methodTitle: string) => void;
  disabled?: boolean;
}

const Method: React.FunctionComponent<Props> = ({
  title,
  numberInputTitle,
  method,
  maxAmount,
  amountRemaining,
  onStartPay,
  disabled,
}) => {
  const dispatch = useDispatch();
  const { i18n } = useI18n();
  const currency = useCurrency();

  const [amount, setAmount] = useState<number | null>(null);
  const [showInput, setShowInput] = useState<boolean>(false);

  const button = useButton({
    onClick: () => setShowInput(true),
    disabled: Boolean(disabled),
  });

  useEffect(() => {
    if (!amount) {
      return;
    }

    onStartPay(amount, method, title);
    setAmount(null);
  }, [amount]);

  return (
    <Box display="flex" alignItems="center">
      <Button {...button} fluid>
        {title}
      </Button>

      {showInput && (
        <NumberInput
          decimal
          initialValueIsPlaceholder
          maxValue={amountRemaining / 100}
          maxCount={(amountRemaining / 100).toString().length + 3}
          title={numberInputTitle}
          onClose={() => setShowInput(false)}
          onSubmit={(n) => {
            const amountToSet = n ? +n * 100 : amountRemaining;

            if (maxAmount != null && amountToSet > maxAmount) {
              dispatch(
                addToast(i18n('POS.PayWith.MaxAmountExceeded', currency.format(maxAmount)), true, null, true),
              );
              setShowInput(false);
              return;
            }

            setAmount(amountToSet);
            setShowInput(false);
          }}
        />
      )}
    </Box>
  );
};

export default Method;
